/**
 * @generated SignedSource<<3785c96450d71659edfe05fdcad96d83>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalsCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "GoalsCell";
};
export type GoalsCell$key = {
  readonly " $data"?: GoalsCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"GoalsCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "GoalsCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraGoalsField"
};

(node as any).hash = "3bef28866cbc81a4082bd51e2208be0f";

export default node;
